// extracted by mini-css-extract-plugin
export default {"container":"notification_link-module__container--2xjHY"};